import { render, staticRenderFns } from "./zhichuCQ.vue?vue&type=template&id=1ecb6310&scoped=true&"
import script from "./zhichuCQ.vue?vue&type=script&lang=js&"
export * from "./zhichuCQ.vue?vue&type=script&lang=js&"
import style0 from "./zhichuCQ.vue?vue&type=style&index=0&id=1ecb6310&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecb6310",
  null
  
)

export default component.exports